import { render, staticRenderFns } from "./AlternativesGrid.vue?vue&type=template&id=61693687"
import script from "./AlternativesGrid.vue?vue&type=script&lang=js"
export * from "./AlternativesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports